import { render, staticRenderFns } from "./McTab.vue?vue&type=template&id=5a4f994a&"
import script from "./McTab.vue?vue&type=script&lang=js&"
export * from "./McTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports